export const ORDER_EXPORT_ID = 'Procesamiento_Carga';

export const ORDER_TITLE = 'ENTREGA';

export const LOCALIZED_PROPERTIES = {
    serial: 'NRO.PEDIDO',
    salesOffice: 'OFICINA_DE_VENTA',
    route: 'RUTA',
    shipTo: 'DESTINATARIO_SHIP_TO',
    address: 'DIRECCION',
    paymentCondition: 'COD.CONDICION_PAGO',
    expeditionCondition: 'COD.CONDICION_EXPEDICION',
    materialCode: 'COD.MATERIAL',
    materialDescription: 'DESCRIPCION',
    warehouse: 'COD.ALMACEN',
    warehouseName: 'DESCRIPCION',
    soldUnitOfMeasure: 'UM',
    soldQuantity: 'CNT.SOLICITADA',
    confirmedErp: 'CNT.CONFIRMADA',
    unitPrice: 'PRECIO',
    note: 'COMENTARIO',
    deliveryQuantity: 'CNT.ENTREGADA',
    deliveryNumber: 'NRO.ENTREGA',
    createDateTimeDate: 'FECHA_CREACION_CSMB',
    createDateTimeHour: 'HORA_CREACION_CSMB',
    updateAuditAtDate: 'FECHA_MODIFICACION',
    updateAuditAtHour: 'HORA_MODIFICACION',
    updatedByUser: 'USUARIO_MODIFICACION',
};
